import React from "react";
import "./terms.scss";
export const Terms = () => {
  return (
    <div className="col-md-8 offset-md-2 terms-div mt card">
      {" "}
      <h4>CONTINUATION, PROBATION AND WITHDRAWAL</h4>
      <h5>CONTINUATION REQUIREMENT:</h5>
      <p>
        The continuation requirement in the University is a CGPA of 1.00 at the
        end of every academic year.
      </p>
      <h5>PROBATION</h5>
      <p>
        Probation is a status granted to a student whose academic performance
        falls be­low an acceptable standard. A student whose cumulative Grade
        Point Average is below 1.50 at the end of a particular year of study
        earns a period of probation for one academic session.
      </p>
      <h5>Limitation of Registration</h5>
      <p>
        Students on probation may not register for more than 15 units per
        semester. The purpose of the restriction is to give the students a
        chance to concentrate on im­proving their performance and thus raising
        their CGPA.
      </p>
      <h5>Warning of Danger of Probation</h5>
      <p>
        Students should be warned by their department if at the end of any
        semester their GPA falls below 1.50.
      </p>
      <h5>Repeating Failed Course Unit(s)</h5>
      <p>
        Subject to the conditions for withdrawal and probation, a student must
        repeat the failed course unit(s) at the next available opportunity,
        provided that the total num­ber of credit units carried during that
        semester does not exceed 24, and the Grade Points earned at all attempts
        shall count towards the CGPA.
      </p>{" "}
      <h5>Temporary Withdrawal from study</h5>
      <p>
        Any student who takes ill and goes into hospital should write and inform
        the Uni­versity about the sickness, and when discharged should write to
        inform the Univer­sity and attach the medical report(s) to the
        application of resumption of study, the medical papers should be
        authenticated by the Health Services Department. Any student who takes
        off without permission or informing the University and stays away for
        more than 2 years should regard himself or herself as being out of the
        programme.
      </p>{" "}
      <h5>WITHDRAWAL</h5>
      <p>
        A student whose cumulative Grade Point Average is below 1.00 at the end
        of one year’s probation shall be required to withdraw from the
        programme. However, in order to minimize waste of human resources,
        consideration should be given to withdraw from programme of study and
        possible transfer to other programmes within the University; provided
        the student meets the departmental and faculty requirements with regards
        to relevant credits and JAMB Score. The Fac­ulty/Department must be
        willing to accept the student.
      </p>{" "}
      <h5>DURATION OF DEGREE PROGRAMMES</h5>
      <p>
        A student who, after the maximum length of time allowed for a degree
        programme, has not obtained a degree, shall have his degree result
        calculated on pass out/fail out basis. The maximum length of time that a
        student shall be permitted to spend on a standard 4-year programme shall
        be 6 years and on a 5-year programme shall be 7 years. This regulation
        does not apply to the MBBS programme which has its own requirements. In
        Part-Time programmes, the appropriate ratio should apply. It is
        mandatory that a student presents and defends his project to earn a
        degree.
      </p>
      <h5>CLASSIFICATION OF DEGREES</h5>
      <p>
        The degree shall be awarded with 1st, 2nd Upper, 2nd Lower, or 3rd Class
        Honours degree. The Cumulative Grade Point Averages for these classes
        shall be
      </p>
      <h5>ACADEMIC ADVISERS</h5>
      <p>
        Every student is attached to an Academic Adviser who is member of the
        academic staff and who will advise him/her on academic affairs as well
        as on personal mat­ters. Academic advisers are expected to follow their
        students’ academic progress and provide counselling to them.
      </p>{" "}
      <p>
        Academic Advisers should give clear information on the notice boards
        about ap­propriate times and place at which they will be available to
        students who which to consult them.
      </p>
      <h5>REGISTRATION OF COURSES</h5>
      <p>
        Please see the Faculty of Science and the University of Port Harcourt
        Handbooks.
      </p>{" "}
      <h5>AUDITING OF COURSE</h5>
      <p>
        Students may attend a course outside their prescribed programme. The
        course shall be recorded in their transcript only if they have
        registered for it with the ap­proval of the Head of Department and the
        Dean of their Faculty and taken the prescribed examination. An audited
        course shall be used in calculating the CGPA.
      </p>
      <h5>CHANGE OF DEGREE PROGRAMME</h5>
      <p>
        1.1 A student who has been admitted to a degree programme on satisfying
        the minimum requirements for entry into the University as well as course
        requirements for the Faculty and Department shall not normally be
        al­lowed to change until he/she has completed the first academic year in
        the degree programme. A student awarded a scholarship in a discipline
        different from that for which he/she is admitted shall be allowed to
        change Faculty or department to that in which the programme specified by
        the Scholarship Award is available, provided that he/she meets the
        requirements of the Faculty or Department to which a change is desired.
      </p>
      <p>
        1.2 Application to change Faculty shall normally be made by the student
        concerned through the Head of the present Department and Faculty, who
        recommends to the Faculty Board on a prescribed form (in quadru­plicate)
        obtainable from the faculty. Duly completed copies of the change of
        programme Form shall be forwarded to the Committee of Provost and Deans
        and the student concerned. Intra-Faculty transfer should be done by the
        Faculty Board and the Committee of Provost and Deans informed.
      </p>
      <p>
        1.3 To qualify for consideration to transfer to the professional
        programmes in Medicine, Engineering and Management Sciences a student
        shall be re­quired to obtain a CGPA of 4 points or above at the time of
        application.
      </p>
      <h5>2. INTER-UNIVERSITY TRANSFER</h5>
      <p>
        2.1 A student from another University may seek a transfer to any of the
        programme of the University of Port Harcourt. Such applicants must
        write, enclosing relevant credentials and transcripts of academic
        record, to the Registrar, who shall normally refer the request to the
        appropriate Head of Department, after considering the application, shall
        make an ap­propriate recommendation through the Dean. The decision of
        the com­mittee of Provost and Deans shall be final. All such
        applications must be processed before the beginning of the academic
        year.
      </p>
      <p>
        2.2 Because of the constraints of space, examinations are currently
        (1997) scheduled to last for three weeks. As soon as adequate classroom
        space is available this should be reduced to two weeks.
      </p>
      <h4>EXAMINATION REGULATION</h4>
      <p>
        The following are the extract from the policy guidelines of the
        University on exami­nation:
      </p>
      <p>
        {" "}
        1. Examiners should ensure that the question papers are prepared under
        condi­tions of maximum security and are ready in time for all
        examinations. Well-packaged question papers must be accompanied by a
        list of Supervi­sors/Invigilators and the relevant forms. The examiners
        should ensure that the question papers, adequately packaged and sealed,
        are submitted to the Su­pervisor at least one hour before the start of
        the examination. Subject only to administrative supervision by the
        Office of the Provost/Deans/Director, the conduct of course examinations
        shall be the responsibility of the Head of De­partment. The Head of
        Department should ensure that examination questions are moderated.
      </p>
      <p>
        2. For each examination there should be a supervisor and invigilators in
        a ratio of at least one invigilator to 50 students, including both male
        and female in­vigilators.
      </p>
      <p>
        3. It is the responsibility of the Parent Department to appoint
        supervisors and invigilators. The list should be forwarded to the Head
        of the Teaching De­partment not later than one week before the
        commencement of semester ex­aminations. Students should be seated
        according to their department and academic staff from their departments
        should invigilate them. Supervisors should be appointed from the rank of
        Senior Lecturer and above and invigila­tors should be other members of
        academic staff, Part-time teachers, where necessary, are also regarded
        as Internal Examiners.
      </p>
      <p>
        4. Supervisors must identify and check students into the examination
        hall using the authenticated register of students for that course. The
        student must show the invigilator his/her registration identify card on
        entry to every examination. He/she must leave these on the desk
        throughout the examination for easy in­spection by the invigilator. The
        supervisor must endorse all examination scripts used by students at
        least 30 minutes after the commencement of the examination.
      </p>
      <p>
        5. The invigilator must ensure that no student removes from the
        examination venue any paper or other examination material except the
        printed question papers where it is allowed. Answer booklets are the
        property of the University and must not be in the possession of
        students.
      </p>
      <p>
        6. During examinations the security must be stepped up, especially
        around examination centre, to ensure the safety of staff and students.
        The security department is to ensure that persons not involved in the
        examinations are al­lowed to loiter around the hall.
      </p>
      <p>7. Not unregistered student is allowed to take any examination.</p>
      <p>
        8. A student should be in the examination room at least 30 minutes
        before the start of the examination. A student who is up to 30 minutes
        late shall be ad­mitted, but shall not be given any extra time.
      </p>
      <p>
        9 A student who arrives more than 30 minutes after the start of the
        examination shall not be admitted. A student may be allowed to leave the
        examination room temporarily before the end of the examination, but must
        NOT:
      </p>
      <ul>
        <li>
          Do so during the first hour of the examination except in cases of
          emer­gency like illness
        </li>
        <li>Do so unaccompanied OR with his scripts.</li>
      </ul>
      <p>
        10. All students must write their name and matriculation number and sign
        the attendance register within the first hour of the examination.
      </p>
      <p>
        11. All students must write their number (not name)) at the appropriate
        places on the cover and pages of the answer booklet.
      </p>
      <p>
        12. No student should keep any handbag, briefcase, books, notebooks, or
        paper near him/her during the examination.
      </p>
      <p>
        13. No students shall directly or accept any assistance during the
        examination, including lending/borrowing any material.
      </p>
      <p>
        14. No student shall continue writing when, at the end of the allotted
        time; the invigilator orders all students to stop writing.
      </p>
      <p>
        15. A student shall avoid-making and/or communicating with any other
        student or with any other person, except with the invigilator if
        necessary.
      </p>
      <p>
        16. Students who disrupt an examination at any venue will have their
        examination cancelled, and they will be required to re-register for the
        course.
      </p>
      <p>
        17. At the end of the examination the supervisor/invigilator should
        ensure that the scripts are checked, properly package and returned along
        with relevant forms to the Chief Examiner.
      </p>
      <p>
        18. A member of staff who fails to turn up for invigilation shall lose a
        monthly examination allowance for each offence and be queried for this
        act the first time. If this is repeated during any other period of
        examination the member of staff will lose the monthly examination on
        allowance for each offence, and will in addition lose the next promotion
        and be warned in writing by the Vice-Chancellor.
      </p>
      <p>
        19. The Provost/Dean is responsible for reporting to the
        Vice-Chancellor, default­ing invigilator. These examination regulations
        apply to all students studying for the award of University of Port
        Harcourt degrees, diplomas and certificate and where appropriate.
      </p>
      <h4>PROCEDURE FOR THE REVIEW OF SCRIPTS OF AGGRIEVED STUDENTS</h4>
      <ol>
        <li>
          {" "}
          Students shall be entitled to see their marked examination scripts if
          they so desire provided appropriate steps are taken to safeguard the
          scripts
        </li>
        <li>
          Any student who is aggrieved about the grading of a course examination
          may petition his/her Head of Department in the first instance. The
          Head Depart­ment shall refer the petition to the Dean of the Faculty,
          who shall cause the scripts to be re-assessed and the scores presented
          to the Faculty Board for determination.
        </li>
        <li>
          A student applying for a review of answer scripts shall be required to
          pay the approved fee to the Bursary Department before commencement of
          the re­view.
        </li>
        <li>
          If the appeal results in a significant improvement (i.e., a change in
          letter grade) on the student’s original grade, the fee so paid shall
          be refunded to the stu­dent within 30 days from the release of the
          result. Students whose letter grade is not marked higher lose their
          money.
        </li>
        <li>
          Application for review of answer scripts must be not later than one
          month from the date of publication of results by the faculty.
        </li>
        <li>
          The application must be personal, i.e., an appeal by someone for the
          review of someone else’s scripts shall not be entertained.{" "}
        </li>
        <li>
          No group appeal by candidates involved in the examination in question
          (or any other group of persons) shall be entertained.
        </li>
      </ol>
      <h5>3. SECRET SOCIETIES/CULTS</h5>
      <p>
        3.1 Secret societies/cults are anti-social and are banned by the
        University. Any, student proved to belong to a secret society will be
        expelled.
      </p>
      <h5>4. TEACHING</h5>
      <p>
        4.1 Because of the present lack of teaching space, the existing practice
        of teaching large classes in a single group may be maintained until the
        situation improves, but an effective public address system and adequate
        teaching aids/assistants must be provided for such classes.
      </p>
      <p>
        4.2 The co-ordination of the teaching of Faculty-and University-wide
        courses involving freshmen should be restricted to senior academic staff
        not be­low the rank of senior Lecturer.
      </p>
      <p>
        4.3 Head of Departments should ensure that lecturers take their teaching
        assignment seriously. In particular course outlines based on the
        ap­proved course description must be made available to students free of
        charge at the commencement of lecture.
      </p>
      <p>
        4.4 Continuous assessment normally constitutes 30% of the marks for the
        course, but may be up to 60% for courses of a practical nature.
        Continu­ous assessment must be administered during the teaching period
        and not as a test immediately preceding the examination nor as an extra
        question on the examination paper.
      </p>
      <h5>5. PUNISHMENT FOR EXAMINATIONMALPRACTICE</h5>
      <p>
        5.1 Any student found guilty of examination malpractice after due
        process should be expelled from the University
      </p>
      <p>
        5.2 This decision should be communicated to all students and their
        sponsors before the commencement of each session. The information should
        be pasted on all notice boards throughout the University and should also
        be contained in each Faculty prospectus so as to give it the widest
        possible publicity.
      </p>
      <p>
        5.3 The decision should take effect immediately after the publication
      </p>
      <p>
        5.4 Members of staff involved in aiding and abetting students in
        examination malpractice should be made to appear before an investigation
        panel. If the member of staff is found guilty, the report should be sent
        to the ap­propriate Disciplinary Committee.
      </p>
      <p>
        5.5 For students involved in an examination malpractice and proven
        guilty, Senate should take the ultimate decision, while for staff, the
        appropriate Disciplinary Committee (as specified in the conditions of
        service) should forward its recommendation to Council.
      </p>
      <p></p>
    </div>
  );
};
